"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    clothing_primary: ["#D0011B", "#F6A623", "#F8E81C", "#417505", "#4990E2", "#9012FE", "#14C66C", "#EB1A86", "#E51138", "#50E3C2", "#1559A8", "#FF660A", "#FF54E4", "#4DCDED", "#A9E560", "#805266"],
    clothing_secondary: ["#F46274", "#F3B753", "#F8ED5E", "#658046", "#75A4DB", "#B66DF7", "#60C893", "#E879B2", "#D66278", "#88E0CC", "#5E7DA1", "#F4A170", "#F793E7", "#91E5FA", "#C9F98D", "#AB6F89"],
    face: ["#000000", "#000000", "#000000", "#000000", "#000000", "#000000", "#000000", "#000000", "#000000", "#000000", "#000000", "#000000", "#000000", "#000000", "#000000", "#000000"],
    skin: ["#FEDCBB", "#F9CDA3", "#DCAE82", "#C68E66", "#AC744D", "#C87A36", "#9C6217", "#A3613A", "#814A2A", "#714B37", "#5C4438", "#7FE86E", "#40B0DD", "#A964E6", "#CCC9A7", "#C75563"],
    weapon: ["#000000", "#4A4A4A", "#624021", "#F5A623", "#B69E24", "#9B9B9B", "#1C75C5", "#820808", "#9012FE", "#BD0FE1", "#44C4A7", "#D7D3D9", "#1D4A78", "#554861", "#4F6B64", "#77674C"],
    hair: ["#000000", "#65401F", "#D5C92D", "#D69224", "#E3E0E0", "#FBF38A", "#4A4A4A", "#EDB04D", "#DE2C2C", "#E7D4F7", "#8D6F0B", "#B2D6FF", "#886E57", "#858585", "#FA98F3", "#87EFD8"],
    accent: ["#970215", "#DF9316", "#E0D226", "#345D05", "#3C79BF", "#7A0FD8", "#10A95C", "#C0126C", "#B30A29", "#42B198", "#0E4483", "#D9580A", "#DB41C2", "#3EB1CD", "#97CE54", "#623F4E"]
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/hash-heroes/lib/data/colors.js
// module id = 353
// module chunks = 0